import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import DishesSection from "@/components/DishesSection";
import MenuSection from "@/components/MenuSection";
import BookingForm from "@/components/BookingForm";
import AboutUs from "@/components/AboutUs";
import LocationSection from "@/components/LocationSection";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CartFab from "@/components/CartFab";

export default function Home() {
  return (
    <main className="bg-ink text-white min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <DishesSection />
      <MenuSection />
      <BookingForm />
      <AboutUs />
      <LocationSection />
      <Footer />
      <CartFab />
      <CartDrawer />
    </main>
  );
}
